<ion-content>
  <ion-header translucent>
    <ion-toolbar class="ion-padding">
      <ion-title size="large">Offline transactions</ion-title>
      <ion-buttons slot="end">
        <ion-button (click)="dismiss()"><ion-icon slot="icon-only" name="close-circle-outline"></ion-icon></ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ng-container *ngFor="let transaction of transactions$ | async">
    <p-panel
      [header]="transaction.url.includes('api/files') ? 'File: ' + transaction.data[0].value : transaction.error || 'Data' + ' Transaction'"
      [toggleable]="true"
      collapsed="true"
      [styleClass]="transaction.error ? 'error-panel' : ''"
    >
      <div class="flex flex-row justify-between gap-4">
        <p class="font-bold">
          Type: <span *ngIf="transaction.url.includes('api/files')">File</span><span *ngIf="!transaction.url.includes('api/files')">Data</span>
        </p>
        <div class="flex gap-2">
          <button pButton (click)="processImage(transaction)" severity="secondary">
            <span class="pi pi-check"></span>
          </button>
          <button pButton (click)="deleteImage(transaction)" severity="secondary">
            <span class="pi pi-trash" style="color: #e38587"></span>
          </button>
        </div>
      </div>
      <p>
        Action: {{ transaction.action }}<br />
        Processed {{ transaction.processed }}<br />
        Data: {{ transaction.data | json }}<br />
        Error: {{ transaction.error | json }}
      </p>
    </p-panel>
  </ng-container>

  <p-button label="Clear all" icon="pi pi-trash" (onClick)="clearAll()" severity="secondary" class="m-4" />
</ion-content>
